import { ArrowRightOutlined, FileDoneOutlined, WarningOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

import {
  SankhyaAdmissionCollectionSerializer,
  VixtingAdmissionCollectionSerializer,
} from '../../types/api';

type CandidateIntegrationAdmissionSentProps = {
  integrationAdmissionStatus?: (
    | SankhyaAdmissionCollectionSerializer
    | VixtingAdmissionCollectionSerializer
  )['status'];
};

const CandidateIntegrationAdmissionSent = ({
  integrationAdmissionStatus,
}: CandidateIntegrationAdmissionSentProps) => {
  if (['NEW', 'SENDING'].includes(integrationAdmissionStatus || '')) {
    return (
      <Tooltip title="Na fila para envio de admissão">
        <ArrowRightOutlined style={{ color: '#fcc903' }} />
      </Tooltip>
    );
  }
  if (integrationAdmissionStatus === 'SENT') {
    return (
      <Tooltip title="Enviado para Admissão">
        <FileDoneOutlined style={{ color: 'blue' }} />
      </Tooltip>
    );
  }
  if (integrationAdmissionStatus === 'FAILED') {
    return (
      <Tooltip title="Erro ao enviar para admissão">
        <WarningOutlined style={{ color: '#ab1423' }} />
      </Tooltip>
    );
  }
  return <></>;
};

export default CandidateIntegrationAdmissionSent;
